import type { FunnelOverlayData, FunnelOverlayMaps } from './types';

export function buildFunnelOverlayMaps(data: FunnelOverlayData | null | undefined): FunnelOverlayMaps {
  const nodesByScreenId: FunnelOverlayMaps['nodesByScreenId'] = {};
  const edgesByTransitionId: FunnelOverlayMaps['edgesByTransitionId'] = {};

  for (const node of data?.nodes ?? []) {
    nodesByScreenId[node.screenId] = node;
  }

  for (const edge of data?.edges ?? []) {
    edgesByTransitionId[edge.canvasTransitionId] = edge;
  }

  return { nodesByScreenId, edgesByTransitionId };
}
